import React from "react";
import { Modal } from "antd";
import Api, { authUser } from "../../services/ServiceApi";
import Renderbtn from "../../pages/uih/wf_controllers/BtnController/renderButton";
import { useSelector } from "react-redux";

export default function StatusInfoModal({
  title,
  visible,
  showSpinIcon,
  statusText,
  mode,
  callbackFunction,
  wrapClassName = "bbtec-theme",
}) {
  const { locale } = authUser();
  const { masterLang: language, factUpdate } = useSelector(
    (state) => state.masterLang
  );

  return (
    <Modal
      title={
        <>
          <h4>
            {title
              ? title
              : factUpdate
              ? language[locale]["statusinfo_title"]
              : `Status Info`}
          </h4>
        </>
      }
      centered
      visible={visible}
      footer={null}
      closable={false}
      wrapClassName={wrapClassName}
    >
      <StatusInfo
        showSpinIcon={showSpinIcon}
        statusText={statusText}
        mode={mode}
        callbackFunction={callbackFunction}
      ></StatusInfo>
    </Modal>
  );
}

export function StatusInfo({
  showSpinIcon,
  statusText,
  mode = "info", // "success", "error", "info"
  callbackFunction,
}) {
  const { locale } = authUser();
  const { masterLang: language, factUpdate } = useSelector(
    (state) => state.masterLang
  );

  return (
    <div className="text-center bbtec-theme">
      {showSpinIcon ? (
        <div className="d-flex justify-content-center">
          <div
            className="spinner-border text-primary"
            role="status"
            style={{ width: "5rem", height: "5rem" }}
          >
            <span className="sr-only">
              {factUpdate
                ? language[locale]["statusinfo_loading"]
                : `Loading...`}
            </span>
          </div>
        </div>
      ) : (
        <img
          src={Api.absoluteUrl(`/img/statusinfo_${mode}.svg`)}
          className="img-fluid"
          alt={mode}
        />
      )}
      <h3 className="statusinfo">{statusText}</h3>
      {!showSpinIcon ? (
        <Renderbtn
          renderBtn={{
            visible: true,
            html_tag: "button",
            type: "Text",
            text: factUpdate ? language[locale]["btn_ok"] : `OK`,
            css: "btn btn-xs btn-submit text-uppercase",
          }}
          btnMiddleware={() => callbackFunction()}
          index="statusinfo_ok"
          item={null}
          disable={false}
        ></Renderbtn>
      ) : null}
    </div>
  );
}
